import MockupPhoneMobDetails from './MockupPhoneMobDetails';

export default MockupPhoneMobDetails;
